import { ShadowCard } from 'components/common/card'
import { Row } from 'components/common/layout'
import { Tag, TagType } from 'components/common/tag'
import { BaseText } from 'components/common/text'
import {
  LinkWithMenuTitle,
  LogoutMenuTitle,
} from 'components/misc/header/link-with-menu-title'
import { analytics } from 'infra/analytics'
import {
  GETTING_HIRED_REWARD_URL,
  GROUP_BY_BLOG_URL,
  GROUP_BY_CONTENT_URL,
} from 'infra/constants'
import React from 'react'
import styled from 'styled-components'
import { useIsLoggedIn } from 'utils/hooks'

const MY_PAGE_PATH = '/my-page/alert-settings'

export const MyDropdownMenu: React.FC = () => {
  const isLoggedIn = useIsLoggedIn()
  return (
    <RoundDropdownMenu>
      {isLoggedIn && (
        <LinkWithMenuTitle href='/scouts/my-profile'>
          마이페이지
        </LinkWithMenuTitle>
      )}
      <LinkWithMenuTitle
        newTab
        href={GETTING_HIRED_REWARD_URL}
        onClick={() => analytics.track('click_mi_request_money_for_employment')}
      >
        취업축하금 신청
      </LinkWithMenuTitle>

      {isLoggedIn && (
        <>
          <LinkWithMenuTitle href={MY_PAGE_PATH}>설정</LinkWithMenuTitle>
          <LogoutMenuTitle />
        </>
      )}
    </RoundDropdownMenu>
  )
}

export const MobileMoreDropdownMenu: React.FC<{
  openSearchModal: () => void
}> = ({ openSearchModal }) => (
  <RoundDropdownMenu>
    <BaseText
      style={{ padding: 15, cursor: 'pointer' }}
      onClick={() => {
        openSearchModal()
        analytics.track('click_mi_search_btn')
      }}
    >
      스타트업 검색
    </BaseText>
    <LinkWithMenuTitle href='/programs'>채용 프로그램</LinkWithMenuTitle>
    <LinkWithMenuTitle newTab href={GROUP_BY_BLOG_URL}>
      블로그
    </LinkWithMenuTitle>
    <LinkWithMenuTitle
      href={GROUP_BY_CONTENT_URL}
      onClick={() => analytics.track('click_mi_header_analysis_resume')}
    >
      <Row style={{ gap: 4 }}>
        이력서 분석기
        <BetaTag variant={TagType.BLUE}>beta</BetaTag>
      </Row>
    </LinkWithMenuTitle>
    <LinkWithMenuTitle href='/biz'>기업 서비스</LinkWithMenuTitle>
  </RoundDropdownMenu>
)

const RoundDropdownMenu = styled(ShadowCard)`
  border: 1px solid ${(p) => p.theme.color.line};
  text-align: center;
  position: absolute;
  padding: 16px 8px;
  top: 56px;
  right: -17px;
  min-width: 150px;
  z-index: 50;
  @media ${(p) => p.theme.deviceSize.mobile} {
    top: 68px;
  }
`

const BetaTag = styled(Tag)`
  padding: 0px 6px;
  border-radius: 100px;
`
